import { createGlobalStyle } from 'styled-components';
import { Theme } from 'utils/color/horizonTheme';

export const PopoverStyles = createGlobalStyle`
  .ant-popover {
    padding: 0 !important;
  }

  .ant-popover-inner {
    border-radius: 0;
    padding: 12px;
  }
  .ant-popover-inner-content {
    padding: unset;
  }

  .ant-popover-arrow {
    border: none;
  }

  ${({ theme }) =>
    theme.themeName === Theme.Dark &&
    `
    .ant-popconfirm {
      .ant-popover-inner,
      .ant-popover-arrow:before {
        background-color: ${theme.tooltipBackground} !important;
      }
  
      .ant-popconfirm-title {
        color: ${theme.headerColor} !important;
      }

      button:not(.ant-btn-primary) {
        background: ${theme.buttonBackgroundColor};

        &:not(.ant-btn-dangerous) {
          border-color: ${theme.buttonBorderColor};
          color: ${theme.headerColor};
        }

        &:hover,
        &:focus {
          background: ${theme.secondaryBackgroundColor};
        }
      }
    }
  `}
`;
